"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _auth = require("@modules/auth");

var _state = _interopRequireDefault(require("./state"));

var _actions = require("./actions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _state.default;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.CHANGE_LANGUAGE_SUCCESS:
      {
        return _objectSpread({}, state, {
          language: action.language
        });
      }

    case _actions.FETCH_ACCOUNT_SUCCESS:
      return _objectSpread({}, state, {
        addresses: action.account.addresses,
        creditCards: action.account.creditCards,
        email: action.account.email,
        firstName: action.account.firstName,
        id: action.account.id,
        language: action.account.language,
        lastName: action.account.lastName,
        newsletterSubscription: action.account.newsletterSubscription,
        postalCode: action.account.postalCode,
        sex: action.account.sex
      });

    case _actions.FETCH_ORDERS_SUCCESS:
      return _objectSpread({}, state, {
        orders: action.orders
      });

    case _auth.authActions.PURGE_ALL:
      return _state.default;

    default:
      return state;
  }
};

exports.default = _default;